import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Alert, FilesGallery } from 'containers/misc'
import { MaterialModal, MaterialControlBar } from 'components/layout'
import getTimeFromDuration from 'helpers/getTimeFromDuration'
import alerts from 'constants/layout/alerts'
import { modal } from 'helpers/decorators'
import styles from './log-detail.styl'
import { getPraiseDescription } from '../../../../helpers/notificationHelper'

@modal.trigger()
class LogDetail extends Component {
  static propTypes = {
    editable: PropTypes.bool,
    onOpenEditLog: PropTypes.func,
    onOpenAlert: PropTypes.func,
    onDeleteLog: PropTypes.func,
    log: PropTypes.object,
    colorClass: PropTypes.string,
    isObservation: PropTypes.bool,
    modalId: PropTypes.string
  }

  handleOpenEditLog = () => this.props.onOpenEditLog(this.props.log)

  handleDeleteLog = () => this.props.onDeleteLog(get(this.props.log, 'id'))

  handleOpenDeleteAlert = () => this.props.onOpenAlert(alerts.DELETE_LOG)

  render() {
    const { colorClass, editable, modalId, log, isObservation } = this.props
    const time = get(log, 'duration') && getTimeFromDuration(log.duration)
    const urls = get(log, 'fileUrls')
    const classNames = [styles.wrap, styles[colorClass]]
    const comments = get(log, 'praises')

    return (
      <MaterialModal.Body
        id={modalId}
        title="Log Detail"
        titleKey={
          isObservation
            ? 'label.journey_observations'
            : 'moduleTitle.log_detail'
        }
        colorClass={colorClass}
      >
        <MaterialModal.Content>
          <div className={classNames.join(' ')}>
            {editable && (
              <MaterialControlBar
                del={{
                  onClick: this.handleOpenDeleteAlert,
                  caption: 'Delete',
                  intlKey: 'button.delete'
                }}
                edit={{
                  onClick: this.handleOpenEditLog,
                  caption: 'Edit',
                  intlKey: 'button.edit'
                }}
              />
            )}

            <div className={styles.inner}>
              <h3 className={styles.description}>{get(log, 'description')}</h3>

              <p className={styles.text}>
                {get(log, 'date') && (
                  <span className={styles.date}>
                    <i className={`ico ico--date ${styles.icon}`} />
                    <span className={styles.caption}>
                      <FormattedDate
                        value={log.date}
                        year="numeric"
                        month="numeric"
                        day="numeric"
                      />
                    </span>
                  </span>
                )}

                {time && (
                  <span className={styles.time}>
                    <i className={`ico ico--time ${styles.icon}`} />
                    <span className={styles.caption}>
                      <FormattedMessage
                        id="dashboard.activity_log_time"
                        defaultMessage="{hours}h {minutes}min"
                        values={time}
                      />
                    </span>
                  </span>
                )}

                {comments && comments.map(item => {
                return (
                  <div className={styles.content}>
                  <div className={styles.description}><p>{getPraiseDescription(item)}</p></div>
                  <div>
                      <div className={styles.praiseIcon}>
                        <i className={`ico ico--face ${styles.ico}`} />
                      </div>
                      <div className={styles.praise}>
                        <p>
                          <FormattedHTMLMessage id='label.translation_message' defaultMessage={get(item, 'translationMessage')} />
                        </p>
                      </div>
                    </div>
                    <div className={styles.clear}></div>
                  </div>
                )
                })}

              </p>
            </div>

            <FilesGallery urls={urls} />
          </div>
        </MaterialModal.Content>

        <Alert id={alerts.DELETE_LOG} onSubmit={this.handleDeleteLog} />
      </MaterialModal.Body>
    )
  }
}

export default LogDetail
